import { render, staticRenderFns } from "./WorkerAddChannel.vue?vue&type=template&id=07152e7e&"
import script from "./WorkerAddChannel.vue?vue&type=script&lang=js&"
export * from "./WorkerAddChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports